$(document).ready(function () {
  // ! relevant items from DOM
  var ageContainer = $("#age-container");
  var ageBG = $("#age-bg");
  var ageYes = $("#age-yes");
  var ageNo = $("#age-no");


  var showAgeCheck = function () {
    ageBG.show();
    ageContainer.addClass("show-age");
  }

  var verifyAge = function () {

    ageYes.click(function () {
      Cookies.set("isOfAge", "oldEnough", {
        expires: 30
      });
      ageBG.hide();
      ageContainer.fadeOut(500);
    });

    ageNo.click(function () {
      Cookies.set("isOfAge", "redirectTooYoung", {
        expires: 30
      });
      window.location.href = "https://www.instagram.com/montywines/";
    });
  }


  if (Cookies.get("isOfAge") != "redirectTooYoung" && Cookies.get("isOfAge") != "oldEnough" ) {
    showAgeCheck();
  }

  if (Cookies.get("isOfAge") == "redirectTooYoung") {
    window.location.href = "https://www.instagram.com/montywines/";
  }


  verifyAge();

});